import { useReducer as e } from "react";
function i(t, r) {
  return r.type === "INITIALIZING" ? {
    ...t,
    status: "initializing"
  } : r.type === "INITIALIZED" ? {
    ...t,
    status: "active",
    initChatbotResponse: r.initChatbotResponse,
    predictionId: r.predictionId,
    isRestart: void 0
  } : r.type === "CHAT_FINISHED" ? {
    ...t,
    predictionId: r.predictionId
  } : r.type === "ERROR" ? {
    ...t,
    status: "error",
    hydrateError: r.error
  } : r.type === "RESET" ? {
    ...t,
    status: "idle",
    initChatbotResponse: void 0,
    predictionId: void 0,
    hydrateError: void 0,
    isRestart: !0
  } : t;
}
function u(t = { status: "idle" }) {
  return e(i, t);
}
export {
  u as useChatbotState
};
